import { render, staticRenderFns } from "./Privacy233.vue?vue&type=template&id=77bb9318&scoped=true"
import script from "./Privacy233.vue?vue&type=script&lang=js"
export * from "./Privacy233.vue?vue&type=script&lang=js"
import style0 from "./Privacy233.vue?vue&type=style&index=0&id=77bb9318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb9318",
  null
  
)

export default component.exports